export default __webpack_public_path__ + "static/g1two-d07b10773cda618f9c8778e1c0fe1501.jpg";